module.exports = __webpack_public_path__ + "static/img/auditing-bg.5fe183b1.png";